import { Link } from 'react-router-dom';

export default function TermsOfUse() {
  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="flex items-center space-x-3 cursor-pointer">
              <img
                src="/site-images/a2330e55c0015410f1b6.png"
                alt="Akten Inc Logo"
                className="object-contain"
                style={{ height: '60px', width: 'auto' }}
              />
            </Link>
            <Link
              to="/"
              className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line mr-2"></i>
              Back to Home
            </Link>
          </div>
        </div>
      </nav>

      <main className="max-w-4xl mx-auto px-6 lg:px-12 py-16">
        <div className="bg-white rounded-lg shadow-sm p-8 lg:p-12">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Terms of Use</h1>
          <p className="text-gray-500 text-sm mb-8">Last Updated: January 2025</p>

          <div className="space-y-8 text-gray-700">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Introduction</h2>
              <p className="leading-relaxed">
                Welcome to the AKTEN INC website. AKTEN INC is a US-based business-to-business (B2B) wholesale 
                and marketplace operations company. By accessing or using this website, you agree to be bound 
                by these Terms of Use. If you do not agree to these terms, please do not use this website.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">2. Informational Purpose Only</h2>
              <div className="bg-amber-50 border-l-4 border-amber-500 p-4 rounded-r-lg mb-4">
                <p className="font-medium text-amber-800">
                  This website is for informational purposes only and does not constitute an offer to sell 
                  or a solicitation of an offer to buy any products or services.
                </p>
              </div>
              <p className="leading-relaxed">
                The content on this website is provided for general informational purposes about AKTEN INC 
                and our B2B wholesale and marketplace operations. Nothing on this website should be construed 
                as a binding offer, contract, or commitment of any kind.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">3. B2B Operations Only</h2>
              <p className="leading-relaxed mb-4">
                AKTEN INC operates exclusively in the business-to-business sector:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-600">
                <li>We do not engage in direct consumer sales</li>
                <li>This website is not intended for individual consumers</li>
                <li>All business relationships are conducted between registered business entities</li>
                <li>Inquiries from individual consumers are outside the scope of our business and will not be processed.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">4. Partnership and Supplier Inquiries</h2>
              <p className="leading-relaxed mb-4">
                Regarding inquiries submitted through this website:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-600">
                <li>All partnership and supplier inquiries are reviewed at the sole discretion of AKTEN INC</li>
                <li>Submission of an inquiry does not create any obligation on the part of AKTEN INC</li>
                <li>We reserve the right to decline any inquiry without providing a reason</li>
                <li>Responses to inquiries depend on business alignment and internal review processes.</li>
              </ul>
              <div className="bg-gray-100 border-l-4 border-gray-400 p-4 rounded-r-lg mt-4">
                <p className="text-gray-700">
                  <strong>No Obligation:</strong> Form submissions, inquiries, or any other communications 
                  through this website do not create any contractual obligation, partnership, or business 
                  relationship between you and AKTEN INC.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">5. Authorized Supply Chains</h2>
              <p className="leading-relaxed mb-4">
                AKTEN INC maintains strict standards regarding supply chain integrity:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-600">
                <li>We work exclusively with authorized supply chains</li>
                <li>No arbitrage or unauthorized resale activities</li>
                <li>No gray market or parallel import operations</li>
                <li>Full compliance with manufacturer authorization requirements</li>
                <li>Verification of supplier credentials and authorization status</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">6. Prohibited Activities</h2>
              <p className="leading-relaxed mb-4">
                Users of this website agree not to:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-600">
                <li>Submit false, misleading, or fraudulent information</li>
                <li>Misrepresent business credentials or authorization status</li>
                <li>Attempt to engage in arbitrage or unauthorized resale through our services</li>
                <li>Use this website for any unlawful purpose</li>
                <li>Interfere with the proper functioning of this website</li>
                <li>Attempt to gain unauthorized access to any systems or data</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">7. Intellectual Property</h2>
              <p className="leading-relaxed">
                All content on this website, including but not limited to text, graphics, logos, images, 
                and software, is the property of AKTEN INC or its content suppliers and is protected by 
                United States and international copyright laws. Unauthorized use, reproduction, or 
                distribution of any content is strictly prohibited.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">8. Disclaimer of Warranties</h2>
              <p className="leading-relaxed">
                This website and its content are provided "as is" without warranties of any kind, either 
                express or implied. AKTEN INC does not warrant that the website will be uninterrupted, 
                error-free, or free of viruses or other harmful components. We make no representations 
                about the accuracy, reliability, or completeness of any information on this website.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">9. Limitation of Liability</h2>
              <p className="leading-relaxed">
                To the fullest extent permitted by law, AKTEN INC shall not be liable for any direct, 
                indirect, incidental, special, consequential, or punitive damages arising out of or 
                related to your use of this website, whether based on warranty, contract, tort, or 
                any other legal theory.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">10. Governing Law</h2>
              <p className="leading-relaxed">
                These Terms of Use shall be governed by and construed in accordance with the laws of 
                the United States of America, without regard to its conflict of law provisions. Any 
                disputes arising under these terms shall be subject to the exclusive jurisdiction of 
                the courts in the United States.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">11. Changes to Terms</h2>
              <p className="leading-relaxed">
                AKTEN INC reserves the right to modify these Terms of Use at any time without prior notice. 
                Changes will be effective immediately upon posting to this website. Your continued use of 
                the website following any changes constitutes acceptance of the revised terms.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-4">12. Contact Information</h2>
              <p className="leading-relaxed mb-4">
                For questions about these Terms of Use, please contact us:
              </p>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="font-medium text-gray-900">AKTEN INC</p>
                <p className="text-gray-600">United States of America</p>
                <p className="text-gray-600 mt-2">
                  <a href="mailto:contact@akteninc.com" className="text-akten hover:text-akten-dark cursor-pointer">
                    contact@akteninc.com
                  </a>
                </p>
              </div>
            </section>
          </div>
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/"
            className="inline-flex items-center px-6 py-3 bg-gray-900 text-white text-sm font-medium rounded-full hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line mr-2"></i>
            Return to Home
          </Link>
        </div>
      </main>

      <footer className="bg-gray-900 text-white py-8">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 text-center">
          <p className="text-gray-400 text-sm">© 2025 AKTEN INC. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
